import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type CopyrightReport from "./CopyrightReport";

@Model()
class CopyrightReportFile extends ApplicationRecord {
  static jsonapiType = "copyright_report_files";

  @Attr({ persist: false }) completedAt: string;

  @BelongsTo() copyrightReport: CopyrightReport;

  @Attr({ persist: false }) copyrightReportId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) filename: string;

  @Attr({ persist: false }) signedUrl: string;
}

export default CopyrightReportFile;
